import styled from "styled-components";
import { deviceDF } from "../../utils/breakPoints";

export const PageContainer = styled.div`
  position: relative;
  z-index: 1000;
`;
export const MenuContainer = styled.div`
  grid-area: menu;
  background-color: #eeeeee;
  padding: 0;
  -webkit-box-shadow: 8px 0px 5px -5px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 8px 0px 5px -5px rgba(0, 0, 0, 0.3);
  box-shadow: 8px 0px 5px -5px rgba(0, 0, 0, 0.3);
  z-index: 1;

  @media ${deviceDF.mobileL} {
    width: 100%;
    -webkit-box-shadow: 0px -8px 5px -5px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px -8px 5px -5px rgba(0, 0, 0, 0.3);
    box-shadow: 0px -8px 5px -5px rgba(0, 0, 0, 0.3);
  }
`;
export const MapContainer = styled.div`
  background-color: #fff;
`;
export const InfoContainer = styled.div`
  margin-top: 0.3rem;
`;
export const InfoHeader = styled.h5`
  font-weight: bold;
  margin: 0;
  margin-bottom: 0.175rem;
`;

export const InfoRow = styled.p`
  margin-bottom: 0.2rem;
`;
export const InfoSeparator = styled.hr`
  color: ${(props) => props.color}; /* old IE */
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.color}; /* Modern Browsers */
  margin-bottom: 0.5rem;
  margin-top: 0;
  border: 0;
`;
// List

export const CardTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: auto;
`;
export const ListItemStyled = styled.li`
  display: flex;
  border-bottom: 1px solid #eeeeee;
`;
export const ListItemHeaderStyled = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  align-items: center;
  font-size: 12px;
  width: 100%;
  margin-bottom: 0.4rem;
`;
export const TitleContainerStyled = styled.div`
  margin: 0 0.2rem;
`;
export const ListItemTitleStyled = styled.h6`
  display: flex;
  /* background-color: greenyellow; */
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
  margin: 0;
  margin-bottom: 0.3rem;
`;
export const LineStyled = styled.hr`
  width: 100%;
  border: 0;
  height: 1px;
  margin: 0.2rem 0;
  background-image: linear-gradient(
    to right,
    rgba(196, 196, 196, 0.1),
    rgba(196, 196, 196, 0.75),
    rgba(196, 196, 196, 0.1)
  );
`;
export const QuantityStyled = styled.span`
  margin-left: 0.2rem;
`;

export const ColumnStyled = styled.div`
  padding: 3px;
  text-align: center;

  flex-direction: ${(props) => (props.dir ? `${props.dir}` : "row")};
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  font-size: 12px;
  /* width: 25%; */
  width: ${(props) => (props.width ? `${props.width}%` : "10%")};
  word-wrap: break-all;
  display: flex;
  align-items: center;
  color: #3c4858;
`;

export const OverTable = styled.div`
  padding: 0 0.6rem;
`;

export const styles = (theme) => ({
  noPaddingTop: {
    paddingTop: "0px",
  },
  backButton: {
    position: "absolute",
    top: "15px",
    right: "20px",
  },
});
